class t extends Error {
  code;
  retriable;
  details;
  constructor(r) {
    super(r.message), this.name = "OptimizerRuntimeError", this.code = r.code, this.retriable = r.retriable, this.details = r.details;
  }
}
export {
  t as OptimizerRuntimeError
};
